export const REGISTRATION_STORAGE_KEY = "ttsds-registration";

let syncedRegistrationData = {
  user: {},
  identities: []
};

if (sessionStorage.getItem(REGISTRATION_STORAGE_KEY)) {
  syncedRegistrationData = JSON.parse(
    sessionStorage.getItem(REGISTRATION_STORAGE_KEY)
  );
}

const state = Object.assign(syncedRegistrationData);

const actions = {
  SAVE_REGISTRATION_FIELD({ commit }, data) {
    commit("SAVE_REGISTRATION_FIELD", data);
  },
  SAVE_IDENTITY_OPTION({ commit }, data) {
    commit("SAVE_IDENTITY_OPTION", data);
  },
  REMOVE_IDENTITY_OPTION({ commit }, data) {
    commit("REMOVE_IDENTITY_OPTION", data);
  },
  CLEAR_REGISTRATION ({commit}) {
    commit('CLEAR_REGISTRATION');
  }
};
const mutations = {
  SAVE_REGISTRATION_FIELD(state, data) {
    state.user = data;
  },
  SAVE_IDENTITY_OPTION(state, data) {
    state.identities = data;
  },
  CLEAR_REGISTRATION (state) {
    state.user = {};
    state.identities = []
  }
};

const getters = {
  getRegistrationUser(state) {
    return state.user;
  },
  getRegistrationFirstName(state) {
    return state.user.firstName;
  },
  getRegistrationEmail(state) {
    return state.user.email;
  },
  getIdentities(state) {
    return state.identities;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
